import { TextArea } from "@flow/frontend/member/components/TextArea";

export function OptionalTextArea(props: { value?: string; label?: string; onChange: (v: string) => void }) {
  return <TextArea value={props.value} label={props.label} required={false} onChange={props.onChange} />;
}
